import { LocationCityRounded, PeopleAlt, WarningRounded } from '@mui/icons-material';
import { Box, styled } from '@mui/material';
import { TypeContributeCompany } from 'src/features/CompanyDetail/Common/config';
import { TypeContributePeople } from 'src/features/PeopleDetail/Common/config';

export enum ContributeTypes {
  Company = 'companies',
  People = 'people',
  ReportWrong = 'report_wrong',
}

export enum StatusContribution {
  Pending = 'pending',
  Reviewing = 'reviewing',
  Approval = 'approved',
  Denied = 'denied',
  Trash = 'trash',
}
export const STATUES_CONTRIBUTE = [
  { value: StatusContribution.Pending, label: 'Pending' },
  { value: StatusContribution.Reviewing, label: 'Reviewing' },
  { value: StatusContribution.Approval, label: 'Approval' },
  { value: StatusContribution.Denied, label: 'Denied' },
  { value: StatusContribution.Trash, label: 'Trash' },
];

export const TABS_CONTRIBUTE: ITabSetting[] = [
  {
    key: ContributeTypes.Company,
    label: 'Company Profile',
    icon: LocationCityRounded,
    disable: false,
  },
  {
    key: ContributeTypes.People,
    label: 'People Profile',
    icon: PeopleAlt,
    disable: false,
  },
  {
    key: ContributeTypes.ReportWrong,
    label: 'Report Wrong Data',
    icon: WarningRounded,
    disable: false,
  },
];

export enum RelationshipContribute {
  OwnEntity = 'own_entity',
  Staff = 'staff',
  BusinessPartner = 'business_partner',
  Supplier = 'supplier',
  Customer = 'customer',
  Other = 'other',
}

export const RELATIONSHIP_CONTRIBUTE_DATA = [
  { value: RelationshipContribute.OwnEntity, label: 'Own entity' },
  { value: RelationshipContribute.Staff, label: 'Staff' },
  { value: RelationshipContribute.BusinessPartner, label: 'Business Partner' },
  { value: RelationshipContribute.Supplier, label: 'Supplier' },
  { value: RelationshipContribute.Customer, label: 'Customer' },
  { value: RelationshipContribute.Other, label: 'Other' },
];

// Common Style WhiteBox use in multiple  tab
export const StyledWhiteBox = styled(Box)(({ theme }) => ({
  padding: theme.spacing(2),
  rowGap: theme.spacing(2),
  display: 'flex',
  flexDirection: 'column',
  borderRadius: theme.shape.borderRadius * 2,
  background: theme.palette.background.default,
}));

export const getColorContributionStatus = (status_code: StatusContribution) => {
  switch (status_code) {
    case StatusContribution.Pending:
      return 'info';
    case StatusContribution.Reviewing:
      return 'warning';
    case StatusContribution.Approval:
      return 'success';
    case StatusContribution.Denied:
      return 'error';
    default:
      return 'default';
  }
};

export const getContributionTypeLabel = (type: TypeContributePeople | TypeContributeCompany) => {
  switch (type) {
    case TypeContributePeople.ContactPeopleProfile:
      return 'Contact  - Personal Profile';
    case TypeContributePeople.SocialPeopleCompanyProfile:
      return 'Social Media - Personal Profile';
    case TypeContributeCompany.ClaimCompanyProfile:
      return 'Claim Your Company Profile';
    case TypeContributeCompany.Email:
      return 'Email';
    case TypeContributeCompany.WebsiteCompanyProfile:
      return 'Website';
    case TypeContributeCompany.RelatedCorporate:
      return 'People Related Corporates';
    case TypeContributeCompany.OtherNames:
      return 'Other Names';
    case TypeContributeCompany.ContactInformation:
      return 'Contact ';
    case TypeContributeCompany.SocialMedia:
      return 'Social Media';
    case TypeContributeCompany.RegisteredAddressCompany:
      return 'Registered Address';
    case TypeContributeCompany.PrimaryAddressCompany:
      return 'Primary Address';
    case TypeContributeCompany.AlternativeAddressCompany:
      return 'Alternative Addresses';
    case TypeContributeCompany.Review:
      return 'Review';
    case TypeContributeCompany.ReportWrongOtherContact:
      return 'Other Contact Company Profile - Report Wrong Data';
    default:
      return type;
  }
};
